import React, { useState, useEffect, useRef, useContext } from 'react';
import style from './pageKit.module.css';
import NavbarSimplified from './component/NavbarSimplified';
import Footer from './component/Footer';
import { Element } from 'react-scroll';
import { Context } from './store/todo_context';
import PopUpPage from './component/PopUpPage';

function PageKit({ children }) {
  const contextApi = useContext(Context);
  const [menuOpen] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [popUpState, setPopUpState] = useState(false);

  const topRef = useRef();

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientY);
  };

const handleTouchMove = (e) => {
  if (touchStart === null) return;

  // TODO: swipe logic si besoin (ex: haut/bas pour cacher/montrer le menu)
};

  const handleTouchEnd = () => {
    setTouchStart(null);
  };

  const handleScroll = () => {
    // Placeholder: scroll behavior logic can go here
  };

  useEffect(() => {
    setPopUpState(contextApi.openAndType);
    document.body.style.overflow = contextApi.openAndType.isOpen ? 'hidden' : '';
  }, [contextApi.openAndType]);

  const closePopup = () => {
    // NOTE: contextApi manages the popUpState; local state not needed anymore
  };

  const cancelPopUpPage = () => {
    contextApi.sendFlexbox({ isOpen: false, type: null, valueOfData: null });
  };

  return (
    <>
      {menuOpen ? (
        <div className={style.popupScreen}>
          <div className={style.popupScreen__sideBar}>
            <NavbarSimplified />
          </div>
        </div>
      ) : (
        <Element
          onClick={closePopup}
          onWheel={handleScroll}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className={style.flexWrapper}>
            <NavbarSimplified />
            <main ref={topRef} className={style.container__wrap__main}>
              {children}
            </main>
            <Footer />
          </div>
        </Element>
      )}

      {popUpState.isOpen && (
        <PopUpPage
          cancelPopUpPage={cancelPopUpPage}
          type={popUpState.type}
          value={popUpState.valueOfData}
        />
      )}
    </>
  );
}

export default PageKit;
